







































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import NumericInput from '@/components/input/NumberInput.vue';
import MultiSelectBlock from '@/components/multiselect/MultiSelectEntity.vue';
import { MultiSelect } from "@/lib/formFactory/multiselect/interface";
import { getList } from '@/api/crud';
import { generateFilter } from '@/utils/filter';

const THERAPIST_SERVICE_IDS = [2, 3];

interface SpecializaionBackend {
    id: number,
    isActive: boolean,
    isCommonPractice: string,
    title: string,
    type: string,
    _actions: string[],
}

@Component({
    components: {
        NumericInput,
        MultiSelectBlock,
    }
})
export default class SubscriptionPackComponent extends Vue {
    @Prop({
        default: () => ({
            limit: '',
            specializations: [],
            medicalServiceTypes: [],
            used: 0,
        })
    }) values!: {
        id?: number,
        limit: number | string,
        specializations: { id: number; value: string }[],
        medicalServiceTypes: { id: number; value: string }[],
        used?: number,
    }
    @Prop({ default: false }) disabled!: boolean;
    @Prop({ default: true }) isEditable!: boolean;
    @Prop({ default: null }) model!: Record<string, any>;

    @Watch('isRestrictSpecializations')
    onIsRestrictSpecializationsChange(value: boolean) {
        if (value) {
            this.loadCommonPracticeSpecializations();

            return;
        }

        this.loadSpecializations();
    }

    get isRestrictSpecializations() {
        return Boolean(
            this.values.medicalServiceTypes.find(specialization => THERAPIST_SERVICE_IDS.includes(specialization.id))
        );
    }

    get isShowUsed() {
        return this.$route.name !== 'subscriptionTypes_edit';
    }

    specializationsModel: MultiSelect | null = null;
    medicalServiceTypesModel: MultiSelect | null = null;

    async loadCommonPracticeSpecializations() {
        const result = await getList('specializations', { page: 1 }, '', generateFilter({ id: 'isCommonPractice', value: 'true' }));

        this.values.specializations = [];
        this.model.specializations.list = result.table.rows.map((specialization: SpecializaionBackend) => ({ id: specialization.id, value: specialization.title }));

        if (result.table.totalItems > 50) {
            await this._loadNextPageSpecializations(2, generateFilter({ id: 'isCommonPractice', value: 'true' }));
        }
    }

    async loadSpecializations() {
        const result = await getList('specializations', { page: 1 });

        this.model.specializations.list = result.table.rows.map((specialization: SpecializaionBackend) => ({ id: specialization.id, value: specialization.title }));

        if (result.table.totalItems > 50) {
            await this._loadNextPageSpecializations(2);

          console.log(this.model.specializations.list);
        }

        console.log(this.model.specializations.list);
    }

    add() {
        this.$emit('add', {
            limit: this.values.limit,
            specializations: this.values.specializations,
            medicalServiceTypes: this.values.medicalServiceTypes
        });
    }

    save() {
        this.$emit('save', {
            id: this.values.id,
            data: {
                limit: this.values.limit,
                specializations: this.values.specializations,
                medicalServiceTypes: this.values.medicalServiceTypes
            },
        });
    }

    remove() {
        this.$emit('remove', this.values.id);
    }

    async _loadNextPageSpecializations(page: number, filter?: string) {
        const result = await getList('specializations', { page: page }, '', filter);

        result.table.rows.each((specialization: SpecializaionBackend) => {
            this.model.specializations.list.push({ id: specialization.id, value: specialization.title });
        });

        if (result.table.totalItems > (50 * page)) {
            await this._loadNextPageSpecializations(page + 1, filter);
        }
    }
}
